import { render, staticRenderFns } from "./splitListSelect.vue?vue&type=template&id=45be8219&scoped=true"
import script from "./splitListSelect.vue?vue&type=script&lang=js"
export * from "./splitListSelect.vue?vue&type=script&lang=js"
import style0 from "./splitListSelect.vue?vue&type=style&index=0&id=45be8219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be8219",
  null
  
)

export default component.exports